import React, { useEffect } from 'react';

const UserActivityTracker = ({ userId, onStatusChange }) => {
  useEffect(() => {
    const socket = new WebSocket(`ws://localhost:8000/ws/activity/${userId}/`);


    socket.onopen = () => {
      console.log('WebSocket connected');
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.status === 'online' || data.status === 'offline') {
        onStatusChange(data.status);
      }
    };

    socket.onclose = () => {
      console.log('WebSocket disconnected');
    };

    return () => {
      socket.close();
    };
  }, [userId, onStatusChange]);

  return null;  // This component doesn't render anything directly
};

export default UserActivityTracker;
